import { useState, useCallback } from "react";

export const NOTIFICATION_TYPES = {
  PUBLIC_SOS: "public_sos",
  DRIVER_APPLIED: "driver_applied",
  PENDING_CASH: "pending_cash",
  NEW_BOOKING: "new_booking",
  EMERGENCY_SOS: "emergency_sos",
  DRIVER_ONLINE: "driver_online",
};

const TYPE_CONFIG = {
  [NOTIFICATION_TYPES.PUBLIC_SOS]: {
    color: "#7C3AED",
    bg: "#F3E8FF",
    label: "Public SOS",
    icon: "📢",
    path: "/public-emergencies",
  },
  [NOTIFICATION_TYPES.EMERGENCY_SOS]: {
    color: "#DC2626",
    bg: "#FEE2E2",
    label: "Emergency SOS",
    icon: "🚨",
    path: "/emergencies",
  },
  [NOTIFICATION_TYPES.DRIVER_APPLIED]: {
    color: "#D97706",
    bg: "#FEF3C7",
    label: "New Driver",
    icon: "🛺",
    path: "/drivers",
  },
  [NOTIFICATION_TYPES.PENDING_CASH]: {
    color: "#059669",
    bg: "#D1FAE5",
    label: "Pending Cash",
    icon: "💵",
    path: "/pending-cash",
  },
  [NOTIFICATION_TYPES.NEW_BOOKING]: {
    color: "#2563EB",
    bg: "#DBEAFE",
    label: "New Booking",
    icon: "📋",
    path: "/bookings",
  },
  [NOTIFICATION_TYPES.DRIVER_ONLINE]: {
    color: "#0891B2",
    bg: "#CFFAFE",
    label: "Driver Online",
    icon: "📍",
    path: "/drivers-map",
  },
};

export function useNotifications() {
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);

  const addNotification = useCallback((type, message, meta = {}) => {
    const config = TYPE_CONFIG[type] || TYPE_CONFIG[NOTIFICATION_TYPES.NEW_BOOKING];
    const newNotif = {
      id: Date.now() + Math.random(),
      type,
      message,
      meta,
      read: false,
      timestamp: new Date(),
      ...config,
    };
    setNotifications((prev) => [newNotif, ...prev].slice(0, 50)); // max 50
    setUnreadCount((prev) => prev + 1);
    return newNotif;
  }, []);

  const markAllRead = useCallback(() => {
    setNotifications((prev) => prev.map((n) => ({ ...n, read: true })));
    setUnreadCount(0);
  }, []);

  const markRead = useCallback((id) => {
    setNotifications((prev) =>
      prev.map((n) => {
        if (n.id === id && !n.read) {
          setUnreadCount((c) => Math.max(0, c - 1));
          return { ...n, read: true };
        }
        return n;
      })
    );
  }, []);

  const clearAll = useCallback(() => {
    setNotifications([]);
    setUnreadCount(0);
  }, []);

  const getConfig = (type) => TYPE_CONFIG[type] || TYPE_CONFIG[NOTIFICATION_TYPES.NEW_BOOKING];

  return {
    notifications,
    unreadCount,
    addNotification,
    markAllRead,
    markRead,
    clearAll,
    getConfig,
    TYPE_CONFIG,
  };
}